export default __webpack_public_path__ + "static/media/banco-caja-social.0a14f2ef.png";